import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    ColorPresetType,
    DirectionChange,
    LightPathType,
    LightShape,
    TherapyConfiguration,
    TherapyState
} from "./therapy-configuration";


export const initialState: TherapyConfiguration = {
    speed: 10,
    sets: 0,
    cycles: -1,
    state: TherapyState.stopped,
    directionChange: DirectionChange.smooth,
    lightSize: 3,
    lightShape: LightShape.round,
    lightPath: LightPathType.left,
    colorPreset: ColorPresetType.light
}

// NOTE: reducers below are pure — no socket I/O here (see DEBT-1).
// Broadcasting the updated config to the socket is handled by
// therapyConfigurationMiddleware.ts, which listens for these same actions
// and reads the post-update state. See store/therapyConfigurationMiddleware.ts.
export const therapyConfigurationSlice = createSlice({
    name: 'therapyConfiguration',
    initialState,
    reducers: {
        setTherapyConfiguration: (state, action:PayloadAction<TherapyConfiguration>) => {
            state.speed = action.payload.speed;
            state.sets = action.payload.sets;
            state.cycles = action.payload.cycles;
            state.state = action.payload.state;
            state.directionChange = action.payload.directionChange;
            state.lightSize = action.payload.lightSize;
            state.lightShape = action.payload.lightShape;
            state.lightPath = action.payload.lightPath;
            state.colorPreset = action.payload.colorPreset;
        },
        setSpeed: (state, action:PayloadAction<number>) => {
            state.speed = action.payload;
        },
        setSets: (state, action:PayloadAction<number>) => {
            state.sets = action.payload;
        },
        setCycles: (state, action:PayloadAction<number>) => {
            state.cycles = action.payload;
        },
        increaseSets: state => {
            state.sets += 1;
        },
        increaseCycles: state => {
            state.cycles += 1;
        },
        setState: (state, action:PayloadAction<TherapyState>) => {
            state.state = action.payload;
        },
        setDirectionChange: (state, action:PayloadAction<DirectionChange>) => {
            state.directionChange = action.payload;
        },
        setLightSize: (state, action:PayloadAction<number>) => {
            state.lightSize = action.payload;
        },
        setLightShape: (state, action:PayloadAction<LightShape>) => {
            state.lightShape = action.payload;
        },
        setLightPath: (state, action:PayloadAction<LightPathType>) => {
            state.lightPath = action.payload;
        },
        setColorPreset: (state, action:PayloadAction<ColorPresetType>) => {
            state.colorPreset = action.payload;
        },
    }
});
export const { setTherapyConfiguration, setCycles, setSpeed, setDirectionChange, setLightShape, setLightSize, setLightPath, setSets, setState, increaseSets, increaseCycles, setColorPreset} = therapyConfigurationSlice.actions;

export default therapyConfigurationSlice.reducer;
